import { isB2BProfileSubmenuItemVisible } from './profileSubmenuVisibility'
import type { NavigationItem, NavigationVisibleContextResult } from './types'

type BuildB2BNavigationItemsOptions = {
  items: NavigationItem[]
  visibleByType: Partial<Record<NavigationItem['type'], boolean>>
  visibleContext: NavigationVisibleContextResult
  isActAs: boolean
  isWebView: boolean
  unreadTotal: number
}

export const buildB2BNavigationItems = ({
  items,
  visibleByType,
  visibleContext,
  isActAs,
  isWebView,
  unreadTotal,
}: BuildB2BNavigationItemsOptions): NavigationItem[] => {
  return items
    .filter((item) => {
      const isVisible = visibleByType[item.type]

      return isVisible ?? true
    })
    .map((item) => {
      if (item.type === 'MyProfile' && item.submenu) {
        return {
          ...item,
          submenu: item.submenu.filter((submenuItem) => {
            return isB2BProfileSubmenuItemVisible(submenuItem, {
              isAdminOrHigher: visibleContext.isAdminOrHigher,
              isStaff: visibleContext.isStaff,
              isAgent: visibleContext.isAgent,
              isPartner: visibleContext.isPartner,
              isFranchise: visibleContext.isFranchise,
              isAllowedToPromote: visibleContext.isAllowedToPromote,
              hasCurrentUser: visibleContext.hasCurrentUser,
              hasAccountId: visibleContext.hasAccountId,
              isActAs,
              isWebView,
            })
          }),
        }
      }

      if (item.type === 'Products' && item.submenu) {
        return {
          ...item,
          submenu: item.submenu.filter((submenuItem) => {
            if (submenuItem.type === 'Global') {
              return visibleContext.showGlobalLink
            }

            return true
          }),
        }
      }

      if (item.type === 'Messages') {
        return {
          ...item,
          unread: unreadTotal,
        }
      }

      return item
    })
}
